var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAvatarPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5001 36.697C43.1108 36.697 46.8486 32.9592 46.8486 28.3485C46.8486 23.7377 43.1108 20 38.5001 20C33.8894 20 30.1516 23.7377 30.1516 28.3485C30.1516 32.9592 33.8894 36.697 38.5001 36.697ZM53 52.0762C53 53.8733 52.6731 55.594 52.0755 57.1821C50.01 51.6932 44.711 47.7881 38.5 47.7881C32.289 47.7881 26.99 51.6932 24.9245 57.1821C24.3269 55.594 24 53.8733 24 52.0762C24 44.068 30.4919 37.5762 38.5 37.5762C46.5081 37.5762 53 44.068 53 52.0762Z",
    fill: "#565656"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/user-avatar-placeholder.26412ab7cf61c4845fd66ba5bdc499a5.svg";
export { ForwardRef as ReactComponent };